import { useFetchCollectionsWallets } from '@basqet-dashboard/common/hooks/queries/collections';
import { useDashboardFeatureEnabled } from '@basqet-dashboard/common/hooks/queries/feature-flags';
import { Wallets } from '@basqet-dashboard/common/pages';
import { IN_HOUSE_FLAGS } from '@basqet-dashboard/common/utils';
import { useFetchStaticVirtualAccount } from '@hooks/queries';
import React, { useState } from 'react';

import { NgnAccountBanner } from '../virtual-accounts/ngn-account-banner';
import { NgnVirtualAccountModal, NgnWalletCardAction } from '../virtual-accounts/virtual-accounts';

const MerchantWallets = () => {
  const [modalState, setModalState] = useState({ open: false, autoCreate: false });
  const { wallets } = useFetchCollectionsWallets();
  const ngnVirtualAccountEnabled = useDashboardFeatureEnabled(IN_HOUSE_FLAGS.NGN_VIRTUAL_ACCOUNT);
  const hasNgnWallet = wallets.some((w) => w.currency?.slug?.toUpperCase() === 'NGN');
  const canShowVirtualAccount = hasNgnWallet && ngnVirtualAccountEnabled;
  const { account, notFound } = useFetchStaticVirtualAccount({ enabled: canShowVirtualAccount });

  const openModal = (autoCreate = false) => {
    if (!canShowVirtualAccount) return;
    setModalState({ open: true, autoCreate });
  };
  const closeModal = () => setModalState({ open: false, autoCreate: false });

  const getCardExtra = (wallet) => {
    if (!canShowVirtualAccount) return null;
    if (wallet.currency?.slug?.toUpperCase() !== 'NGN') return null;
    if (!account) return null;
    return <NgnWalletCardAction account={account} onClick={() => openModal(false)} />;
  };

  const showBanner = canShowVirtualAccount && notFound;
  const banner = showBanner ? <NgnAccountBanner onCtaClick={() => openModal(true)} /> : null;

  return (
    <div className="merchant-wallets">
      <Wallets getCardExtra={getCardExtra} headerSlot={banner} />
      {modalState.open && (
        <NgnVirtualAccountModal autoCreate={modalState.autoCreate} onClose={closeModal} />
      )}
    </div>
  );
};

export { MerchantWallets };
